// extracted by mini-css-extract-plugin
module.exports = {"menuItemDropdown":"scheduler_menuItemDropdown__14L4c","popover":"scheduler_popover__31Qpu"};